export const NO_MATCHED_YOUR_FILTERS: string =
  'No classes matched to applied filters. Try adjusting them to explore more classes.';

export const NO_MATCHED_COMBINED: string =
  'No classes matched to your search query and applied filters. Try adjusting it to explore more classes.';

export const NO_MATCHED_BY_SEARCH: string =
  'No classes matched to your search query. Try adjusting them to explore more classes.';

export const NO_UPCOMING_CLASSES: string = 'You have no upcoming classes';
